function Others() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="46"
      fill="none"
      viewBox="0 2.5 50 46"
    >
      <circle
        cx="33"
        cy="23"
        r="2"
        fill="#20293C"
        transform="rotate(90 33 23)"
      />
      <circle
        cx="23"
        cy="23"
        r="2"
        fill="#20293C"
        transform="rotate(90 23 23)"
      />
      <circle
        cx="23"
        cy="23"
        r="2"
        fill="#20293C"
        transform="rotate(90 23 23)"
      />
      <circle
        cx="13"
        cy="23"
        r="2"
        fill="#20293C"
        transform="rotate(90 13 23)"
      />
    </svg>
  );
}

export default Others;
